export type PreferenceDelai =
  | 'Même jour'
  | 'Un jour'
  | 'Deux jours'
  | 'Trois jours'
  | 'Une semaine'
  | string

export function preferenceDelaiToDays(preference?: PreferenceDelai | null): number | null {
  if (!preference) return null
  switch (preference) {
    case 'Même jour':
      return 0
    case 'Un jour':
      return 1
    case 'Deux jours':
      return 2
    case 'Trois jours':
      return 3
    case 'Une semaine':
      return 7
    default:
      return null
  }
}

export function computeDeadlineDate(
  visiteDate: Date | string,
  preference?: PreferenceDelai | null,
) {
  const days = preferenceDelaiToDays(preference)
  if (days === null) return null
  const date = new Date(visiteDate)
  if (Number.isNaN(date.getTime())) return null
  date.setDate(date.getDate() - days)
  return date
}

export function isWithinDelay(
  visiteDate: Date | string,
  preference?: PreferenceDelai | null,
  now = new Date(),
) {
  const deadline = computeDeadlineDate(visiteDate, preference)
  if (!deadline) return null
  return now.getTime() <= deadline.getTime()
}

export function formatDateFR(date: Date) {
  try {
    return new Intl.DateTimeFormat('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    }).format(date)
  } catch {
    return date.toISOString().slice(0, 10)
  }
}

export function buildPolicyLine(params: {
  label: string
  preference?: PreferenceDelai | null
  visiteDate?: Date | string
}) {
  const { label, preference, visiteDate } = params
  if (!preference) return `${label} : non renseignée`
  if (!visiteDate) return `${label} : ${preference}`
  const deadline = computeDeadlineDate(visiteDate, preference)
  if (!deadline) return `${label} : ${preference}`
  return `${label} : ${preference} (jusqu’au ${formatDateFR(deadline)})`
}
